import script from "./SubstandardList.vue?vue&type=script&lang=ts&setup=true"
export * from "./SubstandardList.vue?vue&type=script&lang=ts&setup=true"

import "./SubstandardList.vue?vue&type=style&index=0&id=29ebee66&lang=scss&scoped=true"
import "./SubstandardList.vue?vue&type=style&index=1&id=29ebee66&lang=css"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29ebee66"]])

export default __exports__